export const assertType = <T>(obj: unknown, ...properties: string[]): obj is T => {
  return obj instanceof Object && properties.every((prop) => prop in obj);
};
